import React, {Component} from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import BoothList from './components/BoothList';
import Content from './components/Content';
import ContentComplete from './components/ContentComplete';
import Ranking from './components/Ranking';
import ImageUpload from './components/ImageUpload';

import './App.css';

class App extends Component {
  render(){
    document.addEventListener('touchmove', function(e) { e.preventDefault(); }, { passive:false });
    return (
      <div className="App">
        <BrowserRouter>
          <Switch>
            <Route exact path="/" component={BoothList} />
            <Route exact path="/upload" component={ImageUpload} />
            <Route path="/:boothId/ranking" component={Ranking} />
            <Route path="/:boothId/result" component={ContentComplete} />
            <Route path="/:boothId" component={Content} />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
